// extracted by mini-css-extract-plugin
export default {"brass-multiselect":"MultiSelect_brass-multiselect__sBqC7"};